import { selectAuth, setLoading } from "@redux";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { topCharoenAPI } from "src/API/topCharoen";
import { EventProgress } from "src/Components/EventActivity/EventProgress";
import { IGetWebsaleTopSpenderExample } from "src/Interfaces/topCharoen";

export const PageEventProgress = () => {
    const { userInfo } = useSelector(selectAuth);
    const dispatch = useDispatch();
    const history = useHistory();
    const [loggedInUser, setLoggedInUser] = useState<IGetWebsaleTopSpenderExample>();

    return <EventProgress userInfo={userInfo} loggedInUser={loggedInUser} />;
};
